module.exports = __webpack_public_path__ + "static/media/TickCheckIcon.6dff3ad5.svg";